import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import Marker from 'components/marker'

import styles from './status.css'

const Status = ({ animated, label, important }) =>
  <div styleName={important ? 'status-important' : 'status-normal'}>
    <Marker animated={animated} />
    <span styleName="label">{label}</span>
  </div>

Status.propTypes = {
  animated: PropTypes.bool,
  important: PropTypes.bool,
  label: PropTypes.string.isRequired,
}

export default CSSModules(Status, styles)



/** WEBPACK FOOTER **
 ** ./src/components/status/status.js
 **/